import { OrderStatus } from "../../objects/orders/orderStatus";
import { CanadianCurrencyCode } from "../../objects/currencyExchange/canadianCurrencyCode";
import { CalculatorHelper } from "./calculatorHelper";
import { LocationUtil } from "../utils/LocationUtil";
import { ESOrder, Order } from "../../objects/orders/order";
import { PropertyHelper } from "./propertyHelper";
import { format, formatDateIso, fromDate } from "ts-date";
import { OrderOptions } from "../../objects/orders/orderOptions";

export class OrderHelper {
    public static getTooltipText(orderStatus: OrderStatus) {
        switch (orderStatus) {
            case OrderStatus.Calculated :
                return "Calculated";
            case OrderStatus.Quoted:
                return "Wait for payment";
            case OrderStatus.Paid:
            case OrderStatus.Refunded:
                return "Preparing Documents";
            case OrderStatus.PrepareDoc:
                return "Sending to Customs";
            case OrderStatus.SentToCustom:
                return "Wait for Customs release";
            case OrderStatus.CustomReleased:
            case OrderStatus.BorderCrossed:
            case OrderStatus.Closed:
                return "Closing case";
        }

        return "Wait";
    }

    public static getOrderIcon(status: OrderStatus): string {
        switch (status) {
            case OrderStatus.Calculated :
                return "iso";
            case OrderStatus.Quoted:
                return "credit_card";
            case OrderStatus.Paid:
            case OrderStatus.Refunded:
                return "description";
            case OrderStatus.PrepareDoc:
                return "contact_mail";
            case OrderStatus.SentToCustom:
                return "local_shipping";
            case OrderStatus.CustomReleased:
                return "beenhere";
            case OrderStatus.BorderCrossed:
            case OrderStatus.Closed:
                return "beenhere";
        }

        return "";
    }

    public static formatValue(value: string, name: string, order: ESOrder, canadianCurrencyCodes: CanadianCurrencyCode[]) {
        switch (name) {
            case 'Order ID':
                return `BB-${order.Id}`;
            case 'Goods' :
            case 'Vehicle/Product':
                return CalculatorHelper.isVehicleES(order) ? 'Vehicle' : 'Product';
            case 'Quote':
            case 'Quick Quote/Full Quote':
                return CalculatorHelper.isQuickQuoteES(order) ? 'Quick Quote' : 'Full Quote';
            case 'GTP' :
                return `${PropertyHelper.getValueFromClassProperty(value, order).toLocaleString('en-us', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${String.isNullOrEmpty(order.TotalCurrencyName) ? '' : order.TotalCurrencyName}`;
            case 'Total Value' :
                return `${PropertyHelper.getValueFromClassProperty(value, order)
                    .toLocaleString('en-us', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${String.isNullOrEmpty(order.CurrencyName) ? '' : order.CurrencyName}`;
            case 'Shipping' :
                return order.IsCommercial ? 'Business shipping' : 'Individual shipping';
            case 'Last Updated':
            case 'Created date':
                return format(new Date(PropertyHelper.getValueFromClassProperty(value, order)), 'MM.DD.YYYY');

            case 'BorderBuddy Customs Clearance ' :
                return `${PropertyHelper.getValueFromClassProperty(value, order).toLocaleString('en-us', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} 
                ${String.isNullOrEmpty(order.TotalCurrencyName) ? '' : order.TotalCurrencyName}`;
        }

        return PropertyHelper.getValueFromClassProperty(value, order);
    }

    public static hasOption(order: Order, flag: OrderOptions): boolean {
        if(order.Flag == null || typeof order.Flag == 'undefined')
            return false;

        return order.Flag.hasFlag(flag);
    }
}



// WEBPACK FOOTER //
// ./app/common/helpers/orderHelper.ts